define(function () {
    const IpsModel = require('civicsBase/ipsModel');
    const utils = require('civicsUtils/general_utilities');

    return IpsModel.extend({
        urlRoot: '/delegate/civics-api/api/cdr/logs/',
        instrumentUrls: {
            building: 'Building/',
            businesslicense: 'BusinessLicense/',
            codeenforcement: 'CodeEnforcement/',
            planning: 'Planning/',
            project: 'Project/',
            tradelicense: 'TradeLicense/',
            use: 'Use/'
            //servicerequest: 'crm/ServiceRequests/'
        },
        url:function(){
            if(this.instrumentType){
                if(this.instrumentType.toLowerCase() == 'servicerequest'){
                    return '/delegate/civics-api/api/crm/servicerequests/'+this.get('application')+'/logs'
                }
                return this.urlRoot+this.instrumentUrls[this.instrumentType.toLowerCase()];
            }
            return 'error';
        }

    });
});